import { useState, useEffect } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { admissionToMeetingType } from "../../../../static/types/commonTypes/admissionToMeetingType";
import '../../../../css/infoBulle.css';
import useAppContext from "../../../../hooks/useAppContext";
import { AppContextType } from "../../../../context/AppContext";

interface AdmissionProps {
  admission: admissionToMeetingType;
  onChange: (admission: Partial<admissionToMeetingType>) => void;
  defaultValue?: string;
  required?: boolean; // Nouvelle prop pour contrôler l'affichage de l'astérisque
}

const AdmissionToMeeting: React.FC<AdmissionProps> = ({ 
  admission, 
  onChange, 
  defaultValue = "Tout actionnaire peut participer aux Assemblées. Chaque action donne droit à une voix.",
  required = true // Par défaut, le champ est requis
}) => {

  
  const {
      draftFormData, setDraftFormData
  } = useAppContext() as AppContextType
  
  const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
  const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }

  const [value, setValue] = useState(admission.admissionText || defaultValue);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Appliquer la valeur par défaut si admission.admissionText est vide
    if (!admission.admissionText?.trim()) {
      setValue(defaultValue);
      onChange({ admissionText: defaultValue });
    }
    
    let draft = parseDraft()
    const tempDraft = { ...draft, admission: defaultValue }
    setDraftFormData( stringifyDraft( tempDraft ))

  }, [admission.admissionText, defaultValue, onChange]);

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {

    const newValue = event.target.value;
    setValue(newValue);
    onChange({ admissionText: newValue || defaultValue });
    
    let draft = parseDraft()
    const tempDraft = { ...draft, admission: newValue || defaultValue }
    setDraftFormData( stringifyDraft( tempDraft ))
  };

  return (
    <div className="tab-content p-4 shadow">
      <p className="text-center">
        <strong>
          La cession d'actions à un tiers à quelque titre que ce soit est
          soumise à l'agrément préalable des associés, statuant à la majorité
          des associés disposant du droit de vote.
        </strong>
      </p>
      <div className="mb-3 row">
        <label htmlFor="Admission" className="col-sm-2 col-form-label">
          <div>
            Admission {required && <strong className="text-danger">*</strong>}
          </div>
          <div className="info-icon-wrapper">
            {/* Ondes */}
            <span className="echo-wave echo-wave-left echo-wave-1" />
            <span className="echo-wave echo-wave-right echo-wave-1" />
            <span className="echo-wave echo-wave-left echo-wave-2" />
            <span className="echo-wave echo-wave-right echo-wave-2" />

            {/* Icône */}
            <FaInfoCircle
              className="icon-zoom-orange"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              onClick={() => setShowTooltip(!showTooltip)}
              aria-label="Information sur l'admission"
            />

            {/* Infobulle */}
            {showTooltip && (
              <div className="info-tooltip-orange">
                <strong>IMPORTANT : </strong>  
                Dans la majorité des cas, le texte ci-dessous est celui utilisé. Toutefois, vérifiez vos statuts et, si besoin, remplacez ce texte par celui de vos statuts.
              </div>
            )}
          </div>
        </label>
        <div className="col-sm-10">
          <textarea
            className="form-control"
            id="admission"
            value={value}
            onChange={handleChange}
            rows={4}
          />
        </div>
      </div>
    </div>
  );
};

export default AdmissionToMeeting;